{
  "_": "The songs, by slot. THE source: apps/client/src/audio/tracks.ts imports this and /music.html fetches it, so the game and the test page can never disagree. Sample positions are on the DECODED asset, at sampleRate. pool: where the song belongs, as tags (owner 5.10.2026): all · friends · meet · flirt · date · k18. A room draws every song tagged 'all', every song tagged with its own kind, and — when the room runs K-18 — every song tagged 'k18'. A song plays ONLY where it is tagged.",
  "songs": {
    "1": {
      "file": "0001.m4a",
      "title": "Keep Me Guessing",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/66bGnXESf9bws5BrDEfElq",
      "sampleRate": 48000,
      "loopStartSample": 893217,
      "loopEndSample": 9198200,
      "exitSamples": [],
      "outroStartSample": 9198200,
      "pool": [
        "friends",
        "meet",
        "date"
      ]
    },
    "2": {
      "file": "0002.m4a",
      "title": "Didn't See That Coming",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/0vM8p5KMVG52ZA3alb88HQ",
      "sampleRate": 48000,
      "loopStartSample": 3175695,
      "loopEndSample": 9041017,
      "exitSamples": [],
      "outroStartSample": 9041017,
      "pool": [
        "friends",
        "meet",
        "date"
      ]
    },
    "3": {
      "file": "0003.m4a",
      "title": "Good Trouble",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/0RpLljtGgr5ilVGio4Dw6t",
      "sampleRate": 48000,
      "loopStartSample": 3801965,
      "loopEndSample": 10779735,
      "exitSamples": [],
      "outroStartSample": 10779735,
      "pool": [
        "flirt",
        "k18"
      ]
    },
    "4": {
      "file": "0004.m4a",
      "title": "Only Everything (More Love)",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/7FgN2hZNG8HIuPGSBVuNwO",
      "sampleRate": 48000,
      "loopStartSample": 3711170,
      "loopEndSample": 11020802,
      "exitSamples": [],
      "outroStartSample": 11020802,
      "pool": [
        "date",
        "flirt"
      ]
    },
    "5": {
      "file": "0005.m4a",
      "title": "How Far",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/5FazkkUlBsYC75Fq07N76u",
      "sampleRate": 48000,
      "loopStartSample": 1962119,
      "loopEndSample": 9051247,
      "exitSamples": [],
      "outroStartSample": 9051247,
      "pool": [
        "flirt",
        "k18"
      ]
    },
    "6": {
      "file": "0006.m4a",
      "title": "Hear Me Out",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/4wusiD2XD62E4QvD0ECeMk",
      "sampleRate": 48000,
      "loopStartSample": 655712,
      "loopEndSample": 8365050,
      "exitSamples": [],
      "outroStartSample": 8365050,
      "pool": [
        "friends",
        "meet",
        "date"
      ]
    },
    "7": {
      "file": "0007.m4a",
      "title": "Soft Launch",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/0pvtHdpdGnoDhTrpgHFsHo",
      "sampleRate": 48000,
      "loopStartSample": 2520752,
      "loopEndSample": 10104961,
      "exitSamples": [],
      "outroStartSample": 10104961,
      "pool": [
        "meet",
        "friends"
      ]
    },
    "8": {
      "file": "0008.m4a",
      "title": "Fire",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/2iamN2CN7rtGmm1bK8REAQ",
      "sampleRate": 48000,
      "loopStartSample": 3322643,
      "loopEndSample": 9376683,
      "exitSamples": [],
      "outroStartSample": 9376683,
      "pool": [
        "flirt",
        "k18"
      ]
    },
    "9": {
      "file": "0009.m4a",
      "title": "Plot Twist",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/5HZKhGUzuNOXiT5iE1zBko",
      "sampleRate": 48000,
      "loopStartSample": 1904981,
      "loopEndSample": 6755553,
      "exitSamples": [],
      "outroStartSample": 6755553,
      "pool": [
        "meet",
        "date",
        "friends"
      ]
    },
    "10": {
      "file": "0010.m4a",
      "title": "Diamond",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/6AM3NatKOpXVKX1gY3yvcr",
      "sampleRate": 48000,
      "loopStartSample": 3096097,
      "loopEndSample": 7586005,
      "exitSamples": [],
      "outroStartSample": 7586005,
      "pool": [
        "flirt",
        "meet",
        "date",
        "friends"
      ]
    },
    "11": {
      "file": "0011.m4a",
      "title": "Gravity",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/32EGR4nWtPu0QuieOPXt2n",
      "sampleRate": 48000,
      "loopStartSample": 2888442,
      "loopEndSample": 8388912,
      "exitSamples": [],
      "outroStartSample": 8388912,
      "pool": [
        "flirt",
        "meet",
        "date",
        "friends"
      ]
    },
    "12": {
      "file": "0012.m4a",
      "title": "Right Now",
      "artist": "Mark Johan",
      "spotify": "https://open.spotify.com/track/5m1j52U2XtpuIztEG2mOCc",
      "sampleRate": 48000,
      "loopStartSample": 4372017,
      "loopEndSample": 11639464,
      "exitSamples": [],
      "outroStartSample": 11639464,
      "pool": [
        "flirt",
        "meet",
        "date",
        "friends"
      ]
    }
  }
}
